'use client';

import { FC } from 'react';

import { Icon } from '@/general/Icons/Icon';
import { Link } from '@/general/components/Link/Link';
import { ControlInputGroup } from '@/general/components/forms/Input/ControlInput/ControlInputGroup';
import { Switch } from '@/general/components/forms/Input/atoms/OptionFieldInput';
import { getPlpUrlWithAvailableFilter } from '@/plp/helpers/getPlpUrlWithFilter';
import { isPlpNoFollow } from '@/plp/helpers/isPlpNoFollow';

import { FilterParams } from '../../PlpFilters.type';

type Props = {
  params: FilterParams;
};

export const AvailableFilterLink: FC<Props> = ({ params }) => {
  const href = getPlpUrlWithAvailableFilter(params);
  const nofollow = isPlpNoFollow(href);
  const value = params.filter.includes('available') ? 'available' : '';
  return (
    <Link href={href} rel={nofollow ? 'nofollow' : undefined} className="no-underline">
      <div className="flex items-center gap-4 px-4 py-3">
        <Icon name="show" />
        <div className="flex-1">
          <ControlInputGroup
            id="state"
            name="state"
            type="switch"
            variant="isolated"
            inputIcon={Switch}
            options={[{ label: 'Show available only', value: 'available' }]}
            inputPlacement="end"
            className="m-0! font-bold"
            value={value}
          />
        </div>
      </div>
    </Link>
  );
};
